<template>
  <div class="examine">
    <div class="examine-header">
      <div class="examine-title">{{ plan.name }}</div>
      <div class="examine-state">
        <div class="examine-state-item" v-if="info.flag === 1">
          <div class="examine-box">
            <div class="examine-state-img">
              <img src="../../../assets/stuImg/examine-wait.png" alt="" />
            </div>
            <div class="examine-state-text">
              <div class="examine-state-title">待审核</div>
              <div class="examine-state-content">
                您的报名信息正在审核中，请耐心等待
              </div>
            </div>
          </div>
        </div>

        <div
          class="examine-state-item examine-finsh"
          v-if="
            info.flag === 2 ||
            info.flag === 5 ||
            info.flag === 6 ||
            info.flag === 7
          "
        >
          <div class="examine-box">
            <div class="examine-state-img">
              <img src="../../../assets/stuImg/examine-finsh.png" alt="" />
            </div>
            <div class="examine-state-text">
              <div class="examine-state-title examine-finsh">审核通过</div>
             
              <div
                class="examine-state-content"
                v-if="info.flag === 2 || info.flag === 5"
              >
                您的报名信息已审核通过
              </div>
            </div>
            
          </div>
          <el-button round type="primary" class="examinebtn" @click="payFee" v-if="isGoPay" >缴费</el-button>
          <!-- <div class="examine-btn" @click="payFee" v-if="isPay == 1">缴费</div> -->
          <el-button type="primary" round @click="downioadtheform" class="pributtom" v-if="rescode==1">
            下载报名登记表
          </el-button>
        </div>

        <div
          class="examine-state-item examine-error"
          v-if="info.flag === 3 || info.flag === 4"
        >
          <div class="examine-box">
            <div class="examine-state-img">
              <img src="../../../assets/stuImg/examine-error.png" alt="" />
            </div>
            <div class="examine-state-text">
              <div class="examine-state-title examine-error">审核不通过</div>
              <div class="examine-state-content" v-if="plan.needAudit != 0">
                <span>原因：</span>
                <span class="examine-error-reason">{{ info.reason }}</span>
              </div>
            </div>
          </div>
          <div v-if="info.flag === 4"></div>
          <div
            v-else-if="
              info.flag === 3 && planInfo.state !== 0 && strDate > endAudits
            "
          ></div>
          <div v-else>
            <div class="examine-btn" @click="goEditsignUpInfo">
              修改报考信息
            </div>
            
          </div>
        </div>
      </div>

      <div class="stu-info-container">
        <div class="info-item">
          <div class="info-title">基础信息</div>
          <div class="info-content">
            <div class="info-text-content">
              <span class="info-label">姓名：</span>
              <span class="info-text">{{ info.realName }}</span>
            </div>
            <div class="info-text-content">
              <span class="info-label">性别：</span>
              <span class="info-text">{{ getSex }}</span>
            </div>
            <div class="info-text-content">
              <span class="info-label">手机号：</span>
              <span class="info-text">{{ info.phone }}</span>
            </div>
            <div class="info-text-content">
              <span class="info-label">证件类型：</span>
              <span class="info-text">{{ getCardType }}</span>
            </div>
            <div class="info-text-content">
              <span class="info-label">证件号：</span>
              <span class="info-text">{{ info.cardNo }}</span>
            </div>
            <div class="avatar-url">
              <img :src="info.photoUrl" alt="" />
            </div>
            <!-- ----- 自定义 ----- -->
            <div
              class="info-text-content"
              v-for="item in studentInfo"
              :key="item.name"
            >
              <span class="info-label" v-if="item.type != 'imageUpload'">{{
                item.displayName + "："
              }}</span>
              <span class="info-text" v-if="item.type != 'imageUpload'">{{
                item.value
              }}</span>
            </div>
            <div
              class="info-text-content-img"
              v-for="item in studentPhotoInfo"
              :key="item.name"
              style="margin-bottom: 8px"
            >
              <span class="info-label">{{ item.displayName + "：" }}</span>
              <img
                :src="item.value"
                alt=""
                @click="showBigImg(item.value, item.displayName)"
              />
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">院校信息</div>
          <div class="info-content">
            <div class="info-text-content">
              <span class="info-label">就读院校：</span>
              <span class="info-text" v-if="info.school">{{
                info.school.name
              }}</span>
            </div>
            <div class="info-text-content">
              <span class="info-label">{{ ischangchun }}</span>
              <span class="info-text" v-if="info.station">{{
                info.station.name
              }}</span>
            </div>
            <!-- 自定义 -->
            <div
              class="info-text-content"
              v-for="item in schoolInfo"
              :key="item.name"
            >
              <span class="info-label" v-if="item.type != 'imageUpload'">{{
                item.displayName + "："
              }}</span>
              <span class="info-text" v-if="item.type != 'imageUpload'">{{
                item.value
              }}</span>
            </div>
            <div
              class="info-text-content-img"
              v-for="item in schoolPhotoInfo"
              :key="item.name"
            >
              <span class="info-label">{{ item.displayName + "：" }}</span>
              <img
                :src="item.value"
                alt=""
                @click="showBigImg(item.value, item.displayName)"
              />
            </div>
          </div>
        </div>

        <!-- 报考信息部分 -->
        <div class="info-item">
          <div class="info-title">报考信息</div>
          <div class="info-content">
            <div
              class="info-text-content info-text-content-col"
              v-if="optionSession"
            >
              <span class="info-label">报考考点：</span>
              <span class="info-text">{{ place }}</span>
            </div>
            <!-- 当前批次未开启 "报名选考点场次" => 报考课程 -->
            <div
              class="info-text-content info-text-content-col"
              v-if="!optionSession"
            >
              <span class="info-label">报考课程：</span>
              <span class="info-text">{{ getCourse }}</span>
            </div>

            <!-- 当前批次开启 "报名选考点场次" => 科目&时间 -->
            <div class="info-text-content info-text-content-col" v-else>
              <div
                v-for="item in timeAndSessionIdDtoList"
                :key="item.courseId"
                style="margin-bottom: 16px"
              >
                <span class="info-label">报考课程：</span>
                <span class="info-text">{{ item.courseName }}</span>
                <br />
                <span class="info-label">考试时间：</span>
                <span class="info-text"
                  >{{ item.beginTime }} -- {{ item.endTime }}</span
                >
              </div>
            </div>
            <div
              class="info-text-content info-text-content-col"
              v-if="optionalExam== 1"
            >
              <span class="info-label">预约考试日期：</span>
              <span class="info-text">{{ info.optionalExamDate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="stataBigImgTitle"
      :visible.sync="isShowBigImg"
      append-to-body
      width="960px"
      height="600px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      class="showBigImg"
    >
      <!-- 弹窗内容 -->
      <img :src="stataBigImg" alt="" />

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowBigImg = false"
          >关闭 {{ stataBigImgTitle }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import stuFoot from "../components/stuFoot";
import { selectOneSignUp } from "@/http/modules/custom";
import { getSinglePlan ,RegisterForm } from "@/http/modules/examSet/examBatch";

export default {
  name: "examine",
  data() {
    return {
      reshref:'',
      rescode:'',
      // 是否显示自定义图片大图弹窗
      isShowBigImg: false,
      // 存储大图的变量
      stataBigImg: "",
      // 存储大图的变量标题
      stataBigImgTitle: "",
      // 长春工程学院?
      ischangchun: "",
      userInfo: {},
      info: {},
      plan: {},
      studentInfo: [],
      studentPhotoInfo: [],
      schoolInfo: [],
      schoolPhotoInfo: [],
      place: "",
      /* ** 是否开启 "报名选考点场次" ** */
      optionSession: "",
      /* ** 科目&时间 数据 */
      timeAndSessionIdDtoList: [],
      isPay: "",
      currentTime: "",
      planInfo: {},
      strDate: "",
      endAudits: "",
      optionalExam:''
    };
  },
  components: {
    stuFoot,
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    this.currentTimes();
    this.RegisterForm()
  },
  computed: {
    /*************************************
     * @this (isGoPay)是否展示缴费按钮
     *************************************/
    isGoPay() {
      
      
      let { flag } = this.info;
      let { startPay, endPay } = this.plan;
      startPay = startPay ? startPay.replace(/\-/g, "/") : "";
      endPay = endPay ? endPay.replace(/\-/g, "/") : "";
      let currentTime = this.currentTime;
      let startPayTime = new Date(startPay).getTime();
      let endPayTime = new Date(endPay).getTime();
      if (
        (flag === 2 || flag === 5) &&
        currentTime < endPayTime &&
        currentTime > startPayTime &&
        this.isPay == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSex() {
      let { sex } = this.info;
      return sex === 0 ? "女" : "男";
    },

    getCardType() {
      const cardType = ["身份证", "护照", "士官证", "港澳台身份证"];
      return cardType[this.info.cardType - 1];
    },
    getCourse() {
      let { course } = this.info;
      let courseStr = "";
      course &&
        course.forEach((item) => {
          courseStr = `${courseStr + item.courseName}、`;
        });
      return courseStr.substring(0, courseStr.length - 1);
    },
  },
  async mounted() {
    this.getCurrentTime();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    await this.getCurrentPlan();
    this.isSetState();
  },
  methods: {
    /* ** getCurrentTime(获取当前时间) ** */
    downioadtheform(){
      if(this.rescode == 1){
        window.open (this.reshref) 
      }
    },
    async RegisterForm(){
      let formid={
        stuIds :this.userInfo.id,
        planId:this.getCurrentGlobalPlanId()
      }
     await RegisterForm(formid).then((res)=>{
        this.rescode = res.code 
        this.reshref = res.data
      })
    },
    getCurrentTime() {
      this.mixin_getServerTime().then(({ data }) => {
        this.currentTime = new Date(
          data ? data.replace(/\-/g, "/") : ""
        ).getTime();
      });
    },
    currentTimes() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      this.strDate = new Date(strDate) * 1;
    },
    showBigImg(url, title) {
      this.stataBigImgTitle = title;
      this.stataBigImg = url;
      this.isShowBigImg = true;
    },
    /***********************************
     * @isSetState 系统是否设置了教学点标题
     ***********************************/
    isSetState() {
      this.$api.system.getConfigData().then((res) => {
        let stationName = "";
        res.data.configList.map((e) => {
          if (e.setName == "stationName") {
            stationName = e.setValue2;
          }
        });
        if (stationName) {
          this.ischangchun = stationName + "：";
        } else {
          this.ischangchun = "教学点：";
        }
      });
    },

    /*********************************
     * @getCurrentPlan 获取当前批次信息
     *********************************/
    async getCurrentPlan() {
      let res = await this.$api.applyManage.getCurrentPlan({
        planId: this.getCurrentGlobalPlanId(),
       
      });
      this.planInfo = res.data;
      if (this.planInfo.needAudit == 1) {
        let endAudit = this.planInfo.endAudit;
        this.endAudits = new Date(endAudit) * 1;
      } else {
        let primaryEndAudit = this.planInfo.primaryEndAudit;
        this.endAudits = new Date(primaryEndAudit) * 1;
      }
      this.isPay = res.data.isPay;
      // 报名是否选择了考点场次
      this.optionalExam  =res.data.optionalExamDate
      this.optionSession = res.data.optionalSession == 1;
      this.plan = res.data;
      let userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      this.$api.applyManage
        .selectOneSignUp({ planId: this.plan.id, stuIds: userInfo.id })
        .then(({ data }) => {
          let { beginSign, endSign } = this.plan;
          beginSign = beginSign ? beginSign.replace(/\-/g, "/") : "";
          endSign = endSign ? endSign.replace(/\-/g, "/") : "";
          let currentTime = this.currentTime;
          let beginSignTime = new Date(beginSign).getTime();
          let endSignTime = new Date(endSign).getTime();
          // 科目&时间
          this.timeAndSessionIdDtoList = data.timeAndSessionIdDtoList;
          // 考点
          this.place = data.place ? data.place.name : "";
          if (
            (currentTime < beginSignTime || currentTime > endSignTime) &&
            data.flag == 0
          ) {
            if (data.lastPlanId) {
              this.isProcess(data.lastPlanId);
            }
          } else {
            this.selectByOne(this.plan.id);
          }
        });
    },
    isProcess(planId) {
      // 1. 修改信息为上一批次
      getSinglePlan({ planId: planId }).then((res) => {
        this.optionSession = res.data.optionalSession == 1;
        this.plan = res.data;
        this.selectByOne(res.data.planId);
      });
    },
    /********************************
     * @selectByOne 获取当前用户信息
     ********************************/
    selectByOne(planid) {
      this.studentInfo = [];
      this.schoolInfo = [];
      this.studentPhotoInfo = [];
      this.schoolPhotoInfo = [];
      selectOneSignUp({ planId: planid, stuIds: this.userInfo.id }).then((res) => {
          this.info = res.data;
          // 科目&时间
          this.timeAndSessionIdDtoList = res.data.timeAndSessionIdDtoList;
          // 考点
          this.place = res.data.place ? res.data.place.name : "";
          res.data.extData.forEach((item) => {
            if (item.title == 1 && item.type != "imageUpload") {
              this.studentInfo.push(item);
            } else if (item.title == 1 && item.type == "imageUpload") {
              this.studentPhotoInfo.push(item);
            } else if (item.title == 2 && item.type != "imageUpload") {
              this.schoolInfo.push(item);
            } else if (item.title == 2 && item.type == "imageUpload") {
              this.schoolPhotoInfo.push(item);
            }
          });
        }
      );
    },

    /**************************
     * @this 跳转去报名
     **************************/
    goEditsignUpInfo() {
      this.$router.push({
        path: "/stuHome/stuApply",
      });
    },

    /**************************
     * @this 跳转去缴费
     **************************/
    payFee() {
      this.$router.push({
        path: "/stuHome/payFee",
      });
    },
  },
};
</script>

<style scoped lang="less">
.showBigImg {
  /deep/ .el-dialog.el-dialog--center {
    border-radius: 8px;
  }
  /deep/ .el-dialog__body {
    display: flex;
    justify-content: center;
    img {
      width: auto;
      height: auto;
    }
  }
}
/deep/ .el-dialog__body {
  overflow: auto;
  width: 880px;
  height: 420px;
  p {
    line-height: 30px;
    color: #45494d;
    padding: 0 40px;
  }
}
.examine {
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  margin-bottom: 72px;
}
.examine-header {
  padding: 32px 48px;
  .examine-title {
    color: #2d2f33;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 32px;
  }
  .examine-state {
    border-top: 1px solid #dfe4f2;
    border-bottom: 1px solid #dfe4f2;
    display: flex;
    justify-content: center;
    .examine-state-item {
      padding: 38px 0;
      .examine-box {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .examine-btn {
        display: inline-flex;
        padding: 8px 26px;
        color: #fff;
        background-color: #006aff;
        border-radius: 100px;
        margin-left: 30px;
        margin-top: 30px;
        cursor: pointer;
      }
      .examinebtn{
        text-align: center;
    padding: 12px 58px;
    display: inline-flex;
    color: #fff;
    background-color: #006aff;
    border-radius: 100px;
    cursor: pointer;
      }
      .examine-state-img {
        height: 48px;
        img {
          width: 48px;
          height: 48px;
          display: block;
        }
      }
      .examine-state-text {
        padding-left: 12px;
        line-height: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .examine-state-title {
          color: #f27900;
          font-weight: bold;
          font-size: 24px;
        }
        .examine-state-content {
          color: #9299a6;
          font-size: 14px;
          margin-top: 5px;
          .examine-error-reason {
            color: #45494d;
          }
        }
      }
    }
  }
  .examine-finsh.examine-state-item {
    .examine-state-title.examine-finsh {
      color: #1dbf60;
    }
  }
  .examine-error.examine-state-item {
    .examine-state-title.examine-error {
      color: #fe5958;
    }
  }
}
.stu-info-container {
  margin-top: 45px;
  .info-item:first-child {
    padding-top: 0;
  }
  .info-item {
    position: relative;
    padding: 32px 0 24px 32px;
    border-bottom: 1px solid #f1f2f5;
    .avatar-url {
      position: absolute;
      top: 80px;
      transform: translateY(-50%);
      right: 0;
      img {
        width: 116px;
        height: 152px;
      }
    }
    .info-title {
      color: #45494d;
      font-size: 16px;
      font-weight: 600;
    }
    .info-content {
      padding: 32px 32px 0 32px;
      display: flex;
      flex-wrap: wrap;
      .info-text-content.info-text-content-col {
        width: 100%;
      }
      .info-text-content-img {
        display: flex;
        align-items: center;
        width: 100%;
        .info-label {
          vertical-align: middle;
          display: inline-block;
          width: 100px;
          color: #9299a6;
          text-align: right;
        }
        img {
          width: 116px;
          height: 152px;
        }
      }
      .info-text-content {
        font-size: 14px;
        min-width: 30%;
        max-width: 90%;
        margin-bottom: 24px;
        .info-label {
          display: inline-block;
          min-width: 100px;
          color: #9299a6;
          text-align: right;
        }
        .info-text {
          color: #737780;
        }
      }
    }
  }
}
.examine-btn-form{
  display: inline-flex;
  padding: 8px 26px;
  color: #fff;
  background-color: #006aff;
  border-radius: 100px;
 margin-left: -20px;
 font-size: .1rem;
  cursor: pointer;
}
.pributtom{
  margin-top: 20px;
  margin-left: 10px;
}
</style>
